import { spawn } from "redux-saga/effects";
import BulkPublishingSaga from "./bulkPublishing/bulkPublishing.saga";
import ClientDashboardSaga from "./clientDashboard/clientDashboard.saga";
import BankStatementDocumentsSaga from "./clientSettings/bankStatementDocuments/bankStatementDocuments.saga";
import TeamConnectionsSaga from "./clientSettings/connections/connections.saga";
import emailForwardingSendersSaga from "./clientSettings/emailForwardingSenders/emailForwardingSenders.saga";
import TeamSettingsSaga from "./clientSettings/team/team.saga";
import CommentParsingSaga from "./commentParsing/commentParsing.saga";
import CommunicationsHubSaga from "./communicationsHub/communicationsHub.saga";
import CompanysSaga from "./companies/companies.saga";
import CompanyDashboardSaga from "./companyDashboard/companyDashboard.saga";
import companyDetailsSaga from "./companyDetails/companyDetails.saga";
import CompanyMembersSaga from "./companyMembers/companyMembers.saga";
import DocumentUploadStatusSaga from "./documentsUpload/status/documentUploadStatus.saga";
import DocumentUploadSaga from "./documentsUpload/upload/documentsUpload.saga";
import LineItemExtractionSaga from "./lineItemExtraction/lineItemExtraction.saga";
import operatorSaga from "./operator/operator.saga";
import reconciliationSaga from "./reconciliation/reconciliation.saga";
import TransactionsSaga from "./transactions/transactions.saga";

export default function* featuresSaga() {
  yield spawn(CompanysSaga);
  yield spawn(ClientDashboardSaga);
  yield spawn(CompanyDashboardSaga);
  yield spawn(CompanyMembersSaga);
  yield spawn(TeamSettingsSaga);
  yield spawn(TeamConnectionsSaga);
  yield spawn(DocumentUploadSaga);
  yield spawn(DocumentUploadStatusSaga);
  yield spawn(emailForwardingSendersSaga);
  yield spawn(TransactionsSaga);
  yield spawn(BulkPublishingSaga);
  yield spawn(BankStatementDocumentsSaga);
  yield spawn(LineItemExtractionSaga);
  yield spawn(operatorSaga);
  yield spawn(reconciliationSaga);
  yield spawn(companyDetailsSaga);
  yield spawn(CommunicationsHubSaga);
  yield spawn(CommentParsingSaga);
}
